import { render } from "./WeightsPage.vue?vue&type=template&id=cd558f68&ts=true"
import script from "./WeightsPage.vue?vue&type=script&lang=ts"
export * from "./WeightsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__